function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.15 5.85v24.3H5.85V5.85h24.3zm-14.275 5.973h-3.083v5.051c.002 3.362.016 3.7.119 4.19.273 1.306 1.114 2.345 2.403 2.968.944.456 2.167.662 3.302.554 1.012-.095 1.957-.407 2.707-.892.377-.244.91-.749 1.14-1.083a4.67 4.67 0 00.715-1.706c.051-.245.057-.676.068-4.676l.011-4.406H20.14l-.001 5.175c-.003 1.938-.015 3.028-.034 3.198-.041.358-.163.787-.287 1.009a1.75 1.75 0 01-.74.685c-.822.39-2.025.249-2.595-.303-.29-.281-.49-.734-.573-1.301-.02-.139-.033-1.771-.033-4.343l-.001-4.12z",
  fill: "#98AAB3",
  fillRule: "nonzero"
});

var SvgCityRailway = function SvgCityRailway(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCityRailway, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cityRailway.2fc70a03.svg";
export { ForwardRef as ReactComponent };